const BALANCE_LOADING = 'BALANCE_LOADING';
const BALANCE_SUCCESS = 'BALANCE_SUCCESS';
const BALANCE_FAILURE = 'BALANCE_FAILURE';

export const balanceActions = {
  BALANCE_LOADING,
  BALANCE_SUCCESS,
  BALANCE_FAILURE,
};
